import React, { memo } from "react";
import { FooterImage, FooterImageContainer } from "./styles";

interface IFooterImageProps {
    src: string;
}

const TableBookingFooterImage = ({ src }: IFooterImageProps) => {
    return (
        <FooterImageContainer>
            <FooterImage src={src} />
        </FooterImageContainer>
    );
};

export default memo(TableBookingFooterImage);
